import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

export const styleSheet = StyleSheet.create({
	answer: {
		margin: 0,
		marginBottom: SPACE[12],
	},
	body: {
		color: THEME.colors.text.main,
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[24],
		maxWidth: 800,
	},
	link: {
		':hover': {
			textDecoration: 'underline',
		},
		color: THEME.colors.primary.main,
		textDecoration: 'none',
	},
	lightning: {
		height: 20,
		width: 20,
	},
	question: {
		lineHeight: 1.5,
	},
	questionTitle: {
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.lg,
		fontWeight: fontWeights.bold,
		margin: 0,
		marginBottom: SPACE[8],
	},
	tipContainer: {
		background: THEME.colors.pill.blue.background,
		borderRadius: THEME.common.borderRadius,
		padding: SPACE[12],
	},
	tipContent: {
		margin: 0,
	},
	tipTitle: {
		alignItems: 'center',
		display: 'flex',
		fontWeight: fontWeights.bold,
		gap: SPACE[4],
		marginBottom: SPACE[4],
	},
});
